module.exports = __webpack_public_path__ + "static/media/image-app-detail@3x.5141a53c.png";